// ShamsiDatePicker.js
import React from "react";
import DatePicker from "react-multi-date-picker";
import { persian, customLocale } from "./customLocale";
import "./ShamsiDatePicker.css";
import { TextField } from "@mui/material";
const ShamsiDatePicker = ({ value, onChange, label, placeholder, onFocus,disabled }) => {
  return (
    <div>
      {
        label && (
          <label>{label}</label>
        )
      }

      <DatePicker
        value={value}
        onChange={onChange}
        calendar={persian}
        locale={customLocale}
        format="YYYY/MM/DD"
        placeholder={placeholder}
        onOpenPickNewDate={false}
        // renderInput={(props) => {
        //   console.log("mamaad")
        //   return <TextField {...props} placeholder={placeholder} label={label} margin="normal" variant="outlined" fullWidth />
        // }}
        // render={(props) => {
        //   return <TextField value={value} onChange={onChange} placeholder={placeholder} label={label} margin="normal" variant="outlined" fullWidth />
        // }}
        render={<TextField
          fullWidth
          label={placeholder || ""}
          placeholder={placeholder || ""}
          value={value}
          onChange={onChange}
          size="small"
          disabled= {disabled}
        />}
      />
    </div>
  );
};

export default ShamsiDatePicker;
